// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__sv53-","tab_content":"tab_tab_content__Qk9YK"};